import { render, staticRenderFns } from "./SharedTitlePage.vue?vue&type=template&id=cceedda4&scoped=true&"
import script from "./SharedTitlePage.vue?vue&type=script&lang=js&"
export * from "./SharedTitlePage.vue?vue&type=script&lang=js&"
import style0 from "./SharedTitlePage.vue?vue&type=style&index=0&id=cceedda4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cceedda4",
  null
  
)

export default component.exports